<script>
import Layout from '@layouts/main.vue'

import axios from 'axios'

import { getFlightConfig } from '@utils/helpers.js'

import moment from 'moment';


export default {
  page() {
    return {
      title: this.user.name,
      meta: [
        {
          name: 'description',
          content: `Graphical seat map.`,
        },
      ],
    }
  },
  components: { Layout },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      seatmapData: [],
      lastUpdated: [{ type: 'seatmaplist', timestamp: null }],
      isLoading: false,
      sideBarVisible: true,
      flightId: null,
      seatmapDataTEST: [
        {
          RowNumber: 1,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: '-',
          SmokingRow: null,
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          Destination: null,
          GraphicalSeatMap: ['Bu', 'Bu', '-', 'Bu', 'Bu'],
          PaxSeats: null,
        },
        {
          RowNumber: 2,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          Destination: null,
          GraphicalSeatMap: ['3', '%', '-', '%', 'i'],
          PaxSeats: [
            {
              SeatMapIndex: 0,
              SeatNumber: '02A',
              PaxName: 'SPECIAL/GUESTMS',
              PaxType: 'F',
              PaxStatus: 'CHECKED',
              PaxGroup: 'C',
              GroupSize: 1,
              Class: 'F',
            },
          ],
        },
        {
          RowNumber: 3,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 4,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 5,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 6,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 7,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: 'E',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          Destination: null,
          GraphicalSeatMap: ['X', 'X', '-', '2X', '3X'],
          PaxSeats: null,
        },
        {
          RowNumber: 8,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 9,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: 'E',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%X', '%X'],
          PaxSeats: null,
        },
        {
          RowNumber: 10,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', 'B', 'B', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 11,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 12,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 13,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 14,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 15,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 16,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 17,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 18,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 19,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 20,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 21,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 22,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 23,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 24,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 25,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 26,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '3', '3'],
          PaxSeats: [
            {
              SeatMapIndex: 6,
              SeatNumber: '26K',
              PaxName: 'HARRIS/LIZ',
              PaxType: 'F',
              PaxStatus: 'CHECKED',
              PaxGroup: 'B',
              GroupSize: 2,
              Class: 'J',
            },
            {
              SeatMapIndex: 7,
              SeatNumber: '26L',
              PaxName: 'HARRIS/MIKEMR',
              PaxType: 'M',
              PaxStatus: 'CHECKED',
              PaxGroup: 'B',
              GroupSize: 2,
              Class: 'J',
            },
          ],
        },
        {
          RowNumber: 27,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 28,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 29,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          Destination: null,
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 30,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '*',
            '*',
            '*',
            '-',
            '2',
            '2',
            '2',
            '2',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: [
            {
              SeatMapIndex: 0,
              SeatNumber: '30A',
              PaxName: 'SMITH/JANEMRS',
              PaxType: 'F',
              PaxStatus: 'BOARDED',
              PaxGroup: 'A',
              GroupSize: 2,
              Class: 'Y',
            },
            {
              SeatMapIndex: 1,
              SeatNumber: '30B',
              PaxName: 'SMITH/JIMMR',
              PaxType: 'M',
              PaxStatus: 'BOARDED',
              PaxGroup: 'A',
              GroupSize: 2,
              Class: 'Y',
            },
            {
              SeatMapIndex: 2,
              SeatNumber: '30C',
              PaxName: 'FAMILY/AMR',
              PaxType: 'M',
              PaxStatus: 'BOARDED',
              PaxGroup: 'D',
              GroupSize: 5,
              Class: 'Y',
            },
            {
              SeatMapIndex: 4,
              SeatNumber: '30D',
              PaxName: 'FAMILY/BMRS',
              PaxType: 'F',
              PaxStatus: 'CHECKED',
              PaxGroup: 'D',
              GroupSize: 5,
              Class: 'Y',
            },
            {
              SeatMapIndex: 5,
              SeatNumber: '30E',
              PaxName: 'FAMILY/CMR',
              PaxType: 'M',
              PaxStatus: 'CHECKED',
              PaxGroup: 'D',
              GroupSize: 5,
              Class: 'Y',
            },
            {
              SeatMapIndex: 6,
              SeatNumber: '30F',
              PaxName: 'FAMILY/DMS',
              PaxType: 'F',
              PaxStatus: 'CHECKED',
              PaxGroup: 'D',
              GroupSize: 5,
              Class: 'Y',
            },
            {
              SeatMapIndex: 7,
              SeatNumber: '30G',
              PaxName: 'FAMILY/ECHD',
              PaxType: 'C',
              PaxStatus: 'CHECKED',
              PaxGroup: 'D',
              GroupSize: 5,
              Class: 'Y',
            },
          ],
        },
        {
          RowNumber: 31,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: 'E',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%X',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%X',
            '%X',
            '-',
            '%',
            '%',
            '%X',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 32,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%X',
            '%X',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 33,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 34,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 35,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 36,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 37,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: 'W',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 38,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: 'W',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 39,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: 'W',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 40,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: 'W',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 41,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: 'W',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 42,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: 'W',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            'P',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: [
            {
              SeatMapIndex: 2,
              SeatNumber: '42C',
              PaxName: 'LALLAPER/JANEMRS',
              PaxType: 'F',
              PaxStatus: 'BOOKED',
              PaxGroup: 'F',
              GroupSize: 1,
              Class: 'Y',
            },
          ],
        },
        {
          RowNumber: 43,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: 'W',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 44,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: 'W',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 45,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            'HB',
            'HB',
            'HB',
            '-',
            'HB',
            'HB',
            'HB',
            'HB',
            'HB',
            '-',
            'HB',
            'HB',
            'HB',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 46,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            'SB',
            'SB',
            'SB',
            '-',
            'SB',
            'SB',
            'SB',
            'SB',
            'SB',
            '-',
            'SB',
            'SB',
            'SB',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 47,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'aBC-DEFGH-JKl',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 48,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 49,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 50,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            'hui',
            'hui',
            'hui',
            '-',
            'hui',
            'hui',
            'hui',
            'hui',
            'hui',
            '-',
            'hui',
            'hui',
            'hui',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 51,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            'hi',
            'hi',
            'hi',
            '-',
            'hi',
            'hi',
            'hi',
            'hi',
            'hi',
            '-',
            'hi',
            'hi',
            'hi',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 52,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            'ui',
            'ui',
            'ui',
            '-',
            'ui',
            'ui',
            'ui',
            'ui',
            'ui',
            '-',
            'ui',
            'ui',
            'ui',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 53,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 54,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 55,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: 'HKG',
          GraphicalSeatMap: [
            'D',
            'D',
            'D',
            '-',
            'D',
            'D',
            'D',
            'D',
            'D',
            '-',
            'D',
            'D',
            'D',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 56,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 57,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: 'AMS',
          GraphicalSeatMap: [
            'D',
            'D',
            'D',
            '-',
            'D',
            'D',
            'D',
            'D',
            'D',
            '-',
            'D',
            'D',
            'D',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 58,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 59,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '2D',
            '2D',
            '2D',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 60,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 61,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 62,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 63,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 64,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 65,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 66,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 67,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 68,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 69,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          SmokingRow: 'F',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          Destination: null,
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
      ],
      seatmapDataTEST1: [
        {
          RowNumber: 1,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 2,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          GraphicalSeatMap: ['3', '%', '-', '%', 'i'],
          PaxSeats: [
            {
              SeatMapIndex: 0,
              SeatNumber: '02A',
              PaxName: 'SPECIAL/GUESTMS',
              PaxType: 'F',
              PaxStatus: 'CHECKED',
              PaxGroup: 'C',
              GroupSize: 1,
              Class: 'F',
            },
          ],
        },
        {
          RowNumber: 3,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 4,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 5,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 6,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 7,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 8,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 9,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-KL        ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 10,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', 'B', '-', 'B', 'B', '-', 'B', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 11,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 12,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 13,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 14,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 15,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 16,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 17,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 18,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 19,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 20,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 21,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 22,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 23,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 24,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 25,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 26,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '3', '3'],
          PaxSeats: [
            {
              SeatMapIndex: 6,
              SeatNumber: '26K',
              PaxName: 'HARRIS/LIZ',
              PaxType: 'F',
              PaxStatus: 'CHECKED',
              PaxGroup: 'B',
              GroupSize: 2,
              Class: 'J',
            },
            {
              SeatMapIndex: 7,
              SeatNumber: '26L',
              PaxName: 'HARRIS/MIKEMR',
              PaxType: 'M',
              PaxStatus: 'CHECKED',
              PaxGroup: 'B',
              GroupSize: 2,
              Class: 'J',
            },
          ],
        },
        {
          RowNumber: 27,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 28,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 29,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB-DF-KL     ',
          GraphicalSeatMap: ['%', '%', '-', '%', '%', '-', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 30,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '*',
            '*',
            '*',
            '-',
            '2',
            '2',
            '2',
            '2',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: [
            {
              SeatMapIndex: 0,
              SeatNumber: '30A',
              PaxName: 'SMITH/JANEMRS',
              PaxType: 'F',
              PaxStatus: 'BOARDED',
              PaxGroup: 'A',
              GroupSize: 2,
              Class: 'Y',
            },
            {
              SeatMapIndex: 1,
              SeatNumber: '30B',
              PaxName: 'SMITH/JIMMR',
              PaxType: 'M',
              PaxStatus: 'BOARDED',
              PaxGroup: 'A',
              GroupSize: 2,
              Class: 'Y',
            },
            {
              SeatMapIndex: 2,
              SeatNumber: '30C',
              PaxName: 'FAMILY/AMR',
              PaxType: 'M',
              PaxStatus: 'BOARDED',
              PaxGroup: 'D',
              GroupSize: 5,
              Class: 'Y',
            },
            {
              SeatMapIndex: 4,
              SeatNumber: '30D',
              PaxName: 'FAMILY/BMRS',
              PaxType: 'F',
              PaxStatus: 'CHECKED',
              PaxGroup: 'D',
              GroupSize: 5,
              Class: 'Y',
            },
            {
              SeatMapIndex: 5,
              SeatNumber: '30E',
              PaxName: 'FAMILY/CMR',
              PaxType: 'M',
              PaxStatus: 'CHECKED',
              PaxGroup: 'D',
              GroupSize: 5,
              Class: 'Y',
            },
            {
              SeatMapIndex: 6,
              SeatNumber: '30F',
              PaxName: 'FAMILY/DMS',
              PaxType: 'F',
              PaxStatus: 'CHECKED',
              PaxGroup: 'D',
              GroupSize: 5,
              Class: 'Y',
            },
            {
              SeatMapIndex: 7,
              SeatNumber: '30G',
              PaxName: 'FAMILY/ECHD',
              PaxType: 'C',
              PaxStatus: 'CHECKED',
              PaxGroup: 'D',
              GroupSize: 5,
              Class: 'Y',
            },
          ],
        },
        {
          RowNumber: 31,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 32,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: 'W',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 33,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: 'W',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 34,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: 'W',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 35,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: 'W',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 36,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: 'W',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 37,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: 'W',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 38,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: 'W',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 39,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 40,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 41,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 42,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 43,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 44,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 45,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 46,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 47,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 48,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 49,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 50,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 51,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 52,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 53,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 54,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 55,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 56,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 57,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 58,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 59,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 60,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 61,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 62,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 63,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 64,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 65,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 66,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 67,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 68,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 69,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFGH-JKL',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
      ],
      seatmapDataTEST2: [
        {
          RowNumber: 1,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: '1',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'Abc-def',
          GraphicalSeatMap: ['%', '%', '%', '-', '%', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 2,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: '1',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'Abc-def',
          GraphicalSeatMap: ['%', '%', '%', '-', '%', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 3,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: '1',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'Abc-def',
          GraphicalSeatMap: ['%', '%', '%', '-', '%', '%', '%'],
          PaxSeats: null,
        },
        {
          RowNumber: 4,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: '1',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'Abc-dEFg-hjK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 5,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: '1',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'Abc-dEFg-hjK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 6,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: '2',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 7,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: '2',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            'T',
            '%',
            '%',
            '-',
            '%',
            '&',
            '%',
            '%',
            '-',
            '%',
            '%',
            '&',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 8,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: '2',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            'T',
            '%',
            '%',
            '-',
            '%',
            '&',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 9,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: '2',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 10,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: '2',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 11,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '2',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 12,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '2',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB--DEFG--JK',
          GraphicalSeatMap: [
            '%',
            '%',
            '-',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '-',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 13,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '2',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB--DEFG--JK',
          GraphicalSeatMap: [
            '%',
            '%',
            '-',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '-',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 14,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '2',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB--DEFG--JK',
          GraphicalSeatMap: [
            '%',
            '%',
            '-',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '-',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 15,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '2',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB--DEFG--JK',
          GraphicalSeatMap: [
            '%',
            '%',
            '-',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '-',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 16,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: '2',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 17,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: '2',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            '&',
            '%',
            '%',
            '-',
            '%',
            '&',
            '%',
            '%',
            '-',
            '%',
            '%',
            '&',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 18,
          Deck: 'LOWER DECK',
          Class: 'F',
          Bay: '3',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            'T',
            '%',
            '%',
            '-',
            '%',
            '&',
            '%',
            '%',
            '-',
            '%',
            '%',
            'T',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 19,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: '3',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB--DEFG--JK',
          GraphicalSeatMap: [
            '%',
            '%',
            '-',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '-',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 20,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: '3',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB--DEFG--JK',
          GraphicalSeatMap: [
            '%',
            '%',
            '-',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '-',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 21,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: '3',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB--DEFG--JK',
          GraphicalSeatMap: [
            '%',
            '%',
            '-',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '-',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 22,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: '3',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB--DEFG--JK',
          GraphicalSeatMap: [
            '%',
            '%',
            '-',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '-',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 23,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: '3',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 24,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: '3',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 25,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: '3',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 26,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: '3',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 27,
          Deck: 'LOWER DECK',
          Class: 'C',
          Bay: '3',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 28,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '4',
          ExitRow: '-',
          Overwing: 'W',
          SeatMap: '-BC-DEFG-HJ-',
          GraphicalSeatMap: [
            '-',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '-',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 29,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '4',
          ExitRow: '-',
          Overwing: 'W',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '4',
            '4',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: [
            {
              SeatMapIndex: 6,
              SeatNumber: '29F',
              PaxName: 'GARCIAGARCIADELONGORIA/ALICIAMISS',
              PaxType: 'F',
              PaxStatus: 'CHECKED',
            },
            {
              SeatMapIndex: 7,
              SeatNumber: '29G',
              PaxName: 'JANEZFREIRE/AGUSTINLORD',
              PaxType: 'M',
              PaxStatus: 'CHECKED',
            },
          ],
        },
        {
          RowNumber: 30,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '4',
          ExitRow: '-',
          Overwing: 'W',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '4',
            '4',
            '%',
            '-',
            '%',
            '4',
            '4',
          ],
          PaxSeats: [
            {
              SeatMapIndex: 5,
              SeatNumber: '30E',
              PaxName: 'GOUTAM/PAWANKUMARIMRS',
              PaxType: 'F',
              PaxStatus: 'CHECKED',
            },
            {
              SeatMapIndex: 6,
              SeatNumber: '30F',
              PaxName: 'GOUTAM/ANILKUMARMR',
              PaxType: 'M',
              PaxStatus: 'CHECKED',
            },
            {
              SeatMapIndex: 10,
              SeatNumber: '30J',
              PaxName: 'JAMESON/DAVIDMR',
              PaxType: 'M',
              PaxStatus: 'CHECKED',
            },
            {
              SeatMapIndex: 11,
              SeatNumber: '30K',
              PaxName: 'JAMESON/ROSEMARYMRS',
              PaxType: 'F',
              PaxStatus: 'CHECKED',
            },
          ],
        },
        {
          RowNumber: 31,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '4',
          ExitRow: '-',
          Overwing: 'W',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '*',
          ],
          PaxSeats: [
            {
              SeatMapIndex: 11,
              SeatNumber: '31K',
              PaxName: 'GIL/DAVIDMR',
              PaxType: 'M',
              PaxStatus: 'BOARDED',
            },
          ],
        },
        {
          RowNumber: 32,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '4',
          ExitRow: '-',
          Overwing: 'W',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '2',
            '2',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: [
            {
              SeatMapIndex: 6,
              SeatNumber: '32F',
              PaxName: 'GOMES/EMANUELMR',
              PaxType: 'M',
              PaxStatus: 'CHECKED',
            },
            {
              SeatMapIndex: 7,
              SeatNumber: '32G',
              PaxName: 'GOMES/JEANMRS',
              PaxType: 'F',
              PaxStatus: 'CHECKED',
            },
          ],
        },
        {
          RowNumber: 33,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '4',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '3',
            '3',
            '3E',
          ],
          PaxSeats: [
            {
              SeatMapIndex: 9,
              SeatNumber: '33H',
              PaxName: 'JARVIS/CAROLMRS',
              PaxType: 'F',
              PaxStatus: 'CHECKED',
            },
            {
              SeatMapIndex: 10,
              SeatNumber: '33J',
              PaxName: 'JARVIS/GARRYMR',
              PaxType: 'M',
              PaxStatus: 'CHECKED',
            },
            {
              SeatMapIndex: 11,
              SeatNumber: '33K',
              PaxName: 'JARVIS/EXST',
              PaxType: 'X',
              PaxStatus: 'CHECKED',
            },
          ],
        },
        {
          RowNumber: 34,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '4',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: [
            {
              SeatMapIndex: 0,
              SeatNumber: '34A',
              PaxName: 'HAMEED/EXST',
              PaxType: 'X',
              PaxStatus: 'BOOKED',
            },
          ],
        },
        {
          RowNumber: 35,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '6',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 36,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '4',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '4',
            '4',
            '4',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: [
            {
              SeatMapIndex: 0,
              SeatNumber: '36A',
              PaxName: 'HAMMOND/GILLIANMRS',
              PaxType: 'F',
              PaxStatus: 'CHECKED',
            },
            {
              SeatMapIndex: 1,
              SeatNumber: '36B',
              PaxName: 'HAMMOND/JOSEPHMR',
              PaxType: 'M',
              PaxStatus: 'CHECKED',
            },
            {
              SeatMapIndex: 2,
              SeatNumber: '36C',
              PaxName: 'HAMMOND/THOMASMR',
              PaxType: 'C',
              PaxStatus: 'CHECKED',
            },
          ],
        },
        {
          RowNumber: 37,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '4',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 38,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '4',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            'T',
            '%',
            '%',
            '-',
            '%',
            '&',
            '%',
            '%',
            '-',
            '%',
            '%',
            'T',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 39,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '5',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            '&',
            '%',
            '%',
            '-',
            '%',
            '&',
            '%',
            '%',
            '-',
            '%',
            '%',
            '&',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 40,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '5',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 41,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '6',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            'n',
            'n',
            'n',
            '-',
            'n',
            'n',
            'n',
            'n',
            '-',
            'n',
            'n',
            'n',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 42,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '7',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            'P',
            'P',
            'P',
            '-',
            'X',
            'X',
            'X',
            'X',
            '-',
            'P',
            'P',
            'P',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 43,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '5',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            'X',
            'X',
            'X',
            'X',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 44,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '5',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: [
            {
              SeatMapIndex: 9,
              SeatNumber: '44H',
              PaxName: 'SHERNER/EXST',
              PaxType: 'X',
              PaxStatus: 'BOOKED',
            },
          ],
        },
        {
          RowNumber: 45,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '5',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 46,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '5',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 47,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '5',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 48,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '5',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 49,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '5',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 50,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '5',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 51,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '6',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'ABC-DEFG-HJK',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 52,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '6',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'aBC-DEFG-HJk',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 53,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '6',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'aBC-DEFG-HJk',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 54,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '6',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'aBC-DEFG-HJk',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 55,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: '6',
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            'T',
            'T',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 56,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            'T',
            'T',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 57,
          Deck: 'LOWER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 58,
          Deck: 'UPPER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            'T',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 59,
          Deck: 'UPPER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB--------JK',
          GraphicalSeatMap: [
            '%',
            '%',
            '-',
            '-',
            '-',
            '-',
            '-',
            '-',
            '-',
            '-',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 60,
          Deck: 'UPPER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB--------JK',
          GraphicalSeatMap: [
            '%',
            '%',
            '-',
            '-',
            '-',
            '-',
            '-',
            '-',
            '-',
            '-',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 61,
          Deck: 'UPPER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB--------JK',
          GraphicalSeatMap: [
            '%',
            '%',
            '-',
            '-',
            '-',
            '-',
            '-',
            '-',
            '-',
            '-',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 62,
          Deck: 'UPPER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB--------JK',
          GraphicalSeatMap: [
            '%',
            '%',
            '-',
            '-',
            '-',
            '-',
            '-',
            '-',
            '-',
            '-',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 63,
          Deck: 'UPPER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'AB--------JK',
          GraphicalSeatMap: [
            '%',
            '%',
            '-',
            '-',
            '-',
            '-',
            '-',
            '-',
            '-',
            '-',
            '%',
            '%',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 64,
          Deck: 'UPPER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            '%',
            '%',
            '-',
            '%',
            '%',
            'T',
          ],
          PaxSeats: null,
        },
        {
          RowNumber: 65,
          Deck: 'UPPER DECK',
          Class: 'Y',
          Bay: null,
          ExitRow: '-',
          Overwing: '-',
          SeatMap: 'abc-defg-hjk',
          GraphicalSeatMap: [
            '&',
            '%',
            '%',
            '-',
            '%',
            '&',
            '&',
            '%',
            '-',
            '%',
            '%',
            '&',
          ],
          PaxSeats: null,
        },
      ],
    }
  },
  computed: {
    flight() {
      return this.$store.getters['flights/getFlightById'](this.flightId)
    },
  },
  timers: {
    getData: { time: 30000, autostart: true, repeat: true },
  },
  watch: {
    '$route.params.flightId': {
      immediate: true,
      handler(flightId) {
        this.flightId = flightId
        this.getData(flightId)
      },
    },
  },
  beforeMount() {
    if (!this.flight) {
      this.$router.push('/flights')
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getFlightConfig: getFlightConfig,
    moment(date, format) {
      return moment(date).format(format)
    },
    getBayText(bay) {
      if (bay) {
        return `Bay ${bay}`
      }
      return ``
    },
    getBayAndClassText(bay, cabinClass) {
      if (bay) {
        return `${bay} / ${cabinClass}`
      }
      return `${cabinClass}`
    },
    getClassBlock(cabinClass) {
      if (cabinClass === 'C') {
        return `classBlockBusiness`
      } else if (cabinClass === 'F') {
        return `classBlockFirst`
      }
      return `classBlockEconomy`
    },
    getDeckWidth(seatmapString) {
      if (seatmapString.length > 0) {
        return `width: ${seatmapString.length * 28}px`
      }
      return `width: 312px`
    },
    getDeckWidest() {
      var widest = 0

      this.seatmapData.forEach((seatmapRow) => {
        if (seatmapRow.SeatMap.trim().length > widest) {
          widest = seatmapRow.SeatMap.trim().length
        }
      })

      return `width: ${widest * 28 + 12}px`
    },
    getPaxText(index, paxSeats, seatNumber, text) {
      if (paxSeats == null) {
        return `${seatNumber.toUpperCase()} ${text}`
      }
      const ps = paxSeats.find((p) => p.SeatMapIndex === index)
      if (ps !== null) {
        return `${ps.SeatNumber}\t${ps.Class}\n${ps.PaxName}\n${ps.PaxStatus}\t${ps.PaxType}\t${ps.PaxGroup}${ps.GroupSize}`
      }
      return null
    },
    getSeatDescription(seatNumber, text) {
      return `${seatNumber.toUpperCase()} ${text}`
    },
    parseGraphicalSeatMapString(seat) {
      return seat.replace('X', '')
    },
    showColumnLetters(row, prevRow) {
      return (
        row.Class !== prevRow.Class ||
        row.SeatMap.toUpperCase() !== prevRow.SeatMap.toUpperCase()
      )
    },
    showDeck(row, prevRow) {
      return row.Deck.toUpperCase() !== prevRow.Deck.toUpperCase()
    },
    showExitRow(exitRow, seat) {
      return exitRow === 'E' && seat.includes('X')
    },
    showDestinationBlock(row) {
      return row.Destination !== null
    },
    getData(flightId) {
      if (!flightId) {
        flightId = this.$route.params.flightId
      }
      this.isLoading = true
      axios
        .get(`${this.$config.apiBaseUrl}seatmap/flightid/${flightId}`)
        .then((response) => {
          const data = response.data.Results[0]
          // Update the timestamp
          const seatmaplist = this.lastUpdated.findIndex(
            (obj) => obj.type === 'seatmaplist'
          )
          this.lastUpdated[seatmaplist].timestamp = response.data.Timestamp

          data.forEach((element, index) => {
            element.id = index
          })
          // Process data
          this.seatmapData = data
        })
        .catch((error) => {
          console.log(error)
          const seatmaplist = this.lastUpdated.findIndex(
            (obj) => obj.type === 'seatmaplist'
          )
          this.lastUpdated[seatmaplist].timestamp = 'FAILED'
        })
        .finally(() => (this.isLoading = false))
    },
  },
}
</script>

<template>
  <Layout id="seatmap" :last-updated="lastUpdated">
    <div class="content-container">
      <div v-if="sideBarVisible" id="sidebar-collapse" class="sidebar collapse">
        <div class="sidebar-content container">
          <div class="app-sidebar text-small">
            <div class="app-sidebar-top text-right text-monospace">
              <p class>
                <span class="text-lg">
                  {{ flight.FlightNumber }}/{{
                  moment(flight.Std, 'DDMMM').toUpperCase()
                  }}
                </span>
                <br />
                ROUTING {{ flight.Destinations }}
                <br />
                EQP {{ flight.Equipment }} {{ flight.Registration }}
                {{ getFlightConfig(flight) }}
                <br />
                {{ flight.Etd ? 'STD/ETD' : 'STD' }}
                {{ moment(flight.Std, 'HH:mm') }} {{ flight.Etd ? '/' : '' }}
                {{ flight.Etd ? moment(flight.Etd, 'HH:mm') : '' }}
                <br />STATUS
                <span
                  class="flight-status"
                  :class="flight.FlightStatus.toLowerCase()"
                >{{ flight.FlightStatus }}</span>
              </p>
            </div>

            <div class="col-lg-1">
              <br />
              <div class="keyHeader">Key:</div>
              <div class="seat" style="width: 232px">
                <div class="availableSeat">
                  <b-icon icon="person" font-scale="1.14"></b-icon>
                  <div class="key">Available</div>
                </div>
                <div class="occupiedSeat">
                  2
                  <div class="key">Occupied</div>
                </div>
                <div class="boardedSeat">
                  <b-icon icon="person-fill" font-scale="1.16"></b-icon>
                  <div class="key">Boarded</div>
                </div>
                <div class="preassignedSeat">
                  <b-icon icon="x-circle" font-scale="1.16"></b-icon>
                  <div class="key">Pre-assigned</div>
                </div>
                <div class="blockedSeat">
                  <b-icon icon="x-octagon-fill" font-scale="1.16"></b-icon>
                  <div class="key">Hard Blocked</div>
                </div>
                <div class="blockedSeat">
                  <b-icon icon="x-octagon" font-scale="1.16"></b-icon>
                  <div class="key">Soft Blocked</div>
                </div>
                <div class="destinationSeat">
                  <b-icon icon="x-octagon" font-scale="1.16"></b-icon>
                  <div class="key">Destination Blocked</div>
                </div>
                <div class="exitSeat">
                  <b-icon icon="backspace" font-scale="1.16"></b-icon>
                  <div class="key">Exit</div>
                </div>
                <div class="toilet">
                  <b-icon icon="alert-square" font-scale="1.16"></b-icon>
                  <div class="key">Toilet</div>
                </div>
                <div class="galleySeat">
                  <b-icon icon="tools" font-scale="1.16"></b-icon>
                  <div class="key">Galley</div>
                </div>
                <div class="aisleSeat">
                  12
                  <div class="key">Aisle</div>
                </div>
                <div class="infantSuitableSeat">
                  <b-icon icon="people-fill" font-scale="1.16"></b-icon>
                  <div class="key">Infant Suitable (i)</div>
                </div>
                <div class="nonInfantSuitableSeat">
                  <b-icon icon="people-fill" font-scale="1.16"></b-icon>
                  <div class="key">Non Infant Suitable (n)</div>
                </div>
                <div class="handicappedSuitableSeat">
                  <b-icon icon="person" font-scale="1.16"></b-icon>
                  <div class="key">Handicapped Suitable (h)</div>
                </div>
                <div class="unminSuitableSeat">
                  <b-icon icon="person" font-scale="1.16"></b-icon>
                  <div class="key">Unmin Suitable (u)</div>
                </div>
                <div class="bulkheadSeat">
                  B
                  <div class="key">Bulkhead</div>
                </div>
                <div class="bufferSeat">
                  B
                  <div class="key">Buffer</div>
                </div>
              </div>
            </div>
          </div>

          <div class="app-sidebar-bottom"></div>
        </div>
      </div>

      <div class="seatmap-content">
        <div class="scrollable-seatmap">
          <br />
          <div class="deckStart" :style="getDeckWidest()">{{seatmapData[0].Deck}}</div>
          <div class="noWing"></div>
          <div class="seatMap" :style="getDeckWidest()">
            <div
              v-for="(columnLetter, col) in seatmapData[0].SeatMap.trim()"
              :key="col"
              class="columnLetter"
            >{{columnLetter}}</div>
          </div>
          <!--div class="attributesHeader">Bay / Class</div-->
          <div>
            <div v-for="(seatmapRow, row) in seatmapData" :key="row">
              <div v-if="row > 0">
                <div v-if="showDeck(seatmapRow, seatmapData[row - 1])">
                  <div class="nonSeatMap">
                    <div class="deckFinish" :style="getDeckWidest()"></div>
                    <div class="blankLine"></div>
                    <div class="deckStart" :style="getDeckWidest()">{{seatmapRow.Deck}}</div>
                  </div>
                </div>
                <div v-if="showColumnLetters(seatmapRow, seatmapData[row - 1])">
                  <div class="noWing"></div>
                  <div class="seatMap" :style="getDeckWidest()">
                    <div
                      v-for="(columnLetter, col) in seatmapRow.SeatMap.trim()"
                      :key="col"
                      class="columnLetter"
                    >{{columnLetter}}</div>
                  </div>
                </div>
              </div>

              <div v-if="seatmapRow.Overwing === 'W'" class="leftWing">W</div>
              <div v-else class="noWing"></div>

              <div class="seatMap" :style="getDeckWidest()">
                <div v-if="showExitRow(seatmapRow.ExitRow, seatmapRow.GraphicalSeatMap[0])">
                  <div class="exitRow"></div>
                </div>

                <div
                  v-for="(graphicalSeat, seat) in seatmapRow.GraphicalSeatMap"
                  :key="seat"
                  class="seat"
                  :class="showExitRow(seatmapRow.ExitRow, graphicalSeat) ? 'is-exit' : ''"
                >
                  <div v-if="graphicalSeat === '-'">
                    <div class="aisleSeat">{{seatmapRow.RowNumber}}</div>
                  </div>
                  <div v-else-if="graphicalSeat === '&'">
                    <div class="galleySeat" title="Galley">
                      <b-icon icon="tools" font-scale="1.16"></b-icon>
                    </div>
                  </div>
                  <div v-else-if="graphicalSeat === 'T'">
                    <div class="toilet" title="Toilet">
                      <b-icon icon="alert-square" font-scale="1.16"></b-icon>
                    </div>
                  </div>
                  <div
                    v-else-if="seatmapRow.SeatMap[seat] === seatmapRow.SeatMap[seat].toLowerCase()"
                  >
                    <div class="noSeat">.</div>
                  </div>
                  <div v-else-if="graphicalSeat === '%' || graphicalSeat === '%X'">
                    <div
                      class="availableSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Available')"
                    >
                      <b-icon icon="person" font-scale="1.14"></b-icon>
                    </div>
                  </div>
                  <div v-else-if="graphicalSeat[0] === '*' || graphicalSeat === '*X'">
                    <div
                      class="boardedSeat"
                      :title="getPaxText(seat, seatmapRow.PaxSeats, seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Boarded')"
                    >
                      <b-icon icon="person-fill" font-scale="1.16"></b-icon>
                    </div>
                  </div>
                  <div v-else-if="graphicalSeat === 'D' || graphicalSeat === 'DX'">
                    <div
                      class="destinationSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Destination Blocked')"
                    >
                      <b-icon icon="x-octagon" font-scale="1.16"></b-icon>
                    </div>
                  </div>
                  <div
                    v-else-if="graphicalSeat[1] === 'D' || (graphicalSeat[1] === 'D' && graphicalSeat[2] === 'X')"
                  >
                    <div
                      class="destinationSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Destination Blocked')"
                    >{{graphicalSeat[0]}}</div>
                  </div>
                  <div v-else-if="graphicalSeat[0] in ['1','2','3','4','5','6','7','8','9']">
                    <div
                      class="occupiedSeat"
                      :title="getPaxText(seat, seatmapRow.PaxSeats, seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Occupied')"
                    >{{parseGraphicalSeatMapString(graphicalSeat)}}</div>
                  </div>
                  <div v-else-if="graphicalSeat === 'HB' || graphicalSeat === 'HBX'">
                    <div
                      class="blockedSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Hard Blocked')"
                    >
                      <b-icon icon="x-octagon-fill" font-scale="1.16"></b-icon>
                    </div>
                  </div>
                  <div v-else-if="graphicalSeat === 'SB' || graphicalSeat === 'SBX'">
                    <div
                      class="blockedSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Soft Blocked')"
                    >
                      <b-icon icon="x-octagon" font-scale="1.16"></b-icon>
                    </div>
                  </div>
                  <div v-else-if="graphicalSeat === 'X'">
                    <div
                      class="exitSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Exit')"
                    >
                      <b-icon icon="backspace" font-scale="1.16"></b-icon>
                    </div>
                  </div>
                  <div v-else-if="graphicalSeat === 'P' || graphicalSeat === 'PX'">
                    <div
                      class="preassignedSeat"
                      :title="getPaxText(seat, seatmapRow.PaxSeats, seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Pre-assigned')"
                    >
                      <b-icon icon="x-circle" font-scale="1.16"></b-icon>
                    </div>
                  </div>
                  <div v-else-if="graphicalSeat === 'B' || graphicalSeat === 'BX'">
                    <div
                      class="bulkheadSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Bulkhead')"
                    >B</div>
                  </div>
                  <div v-else-if="graphicalSeat === 'Bu' || graphicalSeat === 'BuX'">
                    <div
                      class="bufferSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Buffer')"
                    >B</div>
                  </div>
                  <div v-else-if="graphicalSeat === 'i' || graphicalSeat === 'iX'">
                    <div
                      class="infantSuitableSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Infant Suitable')"
                    >
                      <b-icon icon="people-fill" font-scale="1.16"></b-icon>
                    </div>
                  </div>
                  <div v-else-if="graphicalSeat === 'n' || graphicalSeat === 'nX'">
                    <div
                      class="nonInfantSuitableSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Non Infant Suitable')"
                    >
                      <b-icon icon="people-fill" font-scale="1.16"></b-icon>
                    </div>
                  </div>
                  <div v-else-if="graphicalSeat === 'h' || graphicalSeat === 'hX'">
                    <div
                      class="handicappedSuitableSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Handicapped Suitable')"
                    >
                      <b-icon icon="person" font-scale="1.16"></b-icon>
                    </div>
                  </div>
                  <div v-else-if="graphicalSeat === 'u' || graphicalSeat === 'uX'">
                    <div
                      class="unminSuitableSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Unmin Suitable')"
                    >
                      <b-icon icon="person" font-scale="1.16"></b-icon>
                    </div>
                  </div>
                  <div v-else-if="graphicalSeat === 'hui' || graphicalSeat === 'huiX'">
                    <div
                      class="unminSuitableSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Handicapped / Unmin / Infant Suitable')"
                    >{{parseGraphicalSeatMapString(graphicalSeat)}}</div>
                  </div>
                  <div v-else-if="graphicalSeat === 'hu' || graphicalSeat === 'huX'">
                    <div
                      class="unminSuitableSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Handicapped / Unmin Suitable')"
                    >{{parseGraphicalSeatMapString(graphicalSeat)}}</div>
                  </div>
                  <div v-else-if="graphicalSeat === 'hi' || graphicalSeat === 'hiX'">
                    <div
                      class="unminSuitableSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Handicapped / Infant Suitable')"
                    >{{parseGraphicalSeatMapString(graphicalSeat)}}</div>
                  </div>
                  <div v-else-if="graphicalSeat === 'ui' || graphicalSeat === 'uiX'">
                    <div
                      class="unminSuitableSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Unmin / Infant Suitable')"
                    >{{parseGraphicalSeatMapString(graphicalSeat)}}</div>
                  </div>
                  <div v-else-if="graphicalSeat === 'hun' || graphicalSeat === 'hunX'">
                    <div
                      class="unminSuitableSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Handicapped / Unmin / Non Infant Suitable')"
                    >{{parseGraphicalSeatMapString(graphicalSeat)}}</div>
                  </div>
                  <div v-else-if="graphicalSeat === 'hn' || graphicalSeat === 'hnX'">
                    <div
                      class="unminSuitableSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Handicapped / Non Infant Suitable')"
                    >{{parseGraphicalSeatMapString(graphicalSeat)}}</div>
                  </div>
                  <div v-else-if="graphicalSeat === 'un' || graphicalSeat === 'unX'">
                    <div
                      class="unminSuitableSeat"
                      :title="getSeatDescription(seatmapRow.RowNumber + seatmapRow.SeatMap[seat], 'Unmin / Non Infant Suitable')"
                    >{{parseGraphicalSeatMapString(graphicalSeat)}}</div>
                  </div>
                  <div v-else>{{parseGraphicalSeatMapString(graphicalSeat)}}</div>
                </div>

                <div
                  v-if="showExitRow(seatmapRow.ExitRow, seatmapRow.GraphicalSeatMap[seatmapRow.GraphicalSeatMap.length - 1])"
                >
                  <div class="exitRow"></div>
                </div>
              </div>

              <div v-if="seatmapRow.Overwing === 'W'" class="rightWing">W</div>
              <div v-else class="noWing"></div>

              <!--div class="classBlock">
                <div :class="getClassBlock(seatmapRow.Class)">{{seatmapRow.Class}}</div>
              </div-->
              <div
                v-if="showDestinationBlock(seatmapRow)"
                class="destinationBlock"
              >{{seatmapRow.Destination}}</div>
            </div>
          </div>

          <div class="deckFinish" :style="getDeckWidest()"></div>
          <br />
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
.seatmap-content {
  margin-left: 54px;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.scrollable-seatmap {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  box-sizing: content-box;
}
.seatMap {
  display: inline-flex;
  background-color: lightgrey;
  justify-content: center;
}
.nonSeatMap {
  background-color: transparent;
}
.blankLine {
  display: inline-block;
  background-color: transparent;
  margin-bottom: 6px;
}
.columnLetter {
  display: inline-block;
  background-color: lightgrey;
  font-size: 160%;
  width: 28px;
  height: 28px;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 10px;
}
.deckStart {
  border-radius: 45px 45px 0px 0px;
  background-color: lightgrey;
  height: 54px;
  font-size: 112%;
  padding-top: 8px;
  margin-left: 34px;
  text-transform: uppercase;
  text-align: center;
}
.deckFinish {
  border-radius: 0px 0px 55px 55px;
  background: lightgrey;
  padding: 10px;
  height: 30px;
  margin-left: 34px;
}
.keyHeader {
  font-size: 136%;
  width: 64px;
}
.key {
  display: inline-block;
  font-weight: bold;
  width: 196px;
  padding: 2px;
  text-align: left;
  margin-left: 12px;
}
.attributes {
  display: inline-block;
  font-size: 90%;
  margin-left: 8px;
}
.leftWing {
  border-radius: 10px 0px 0px 10px;
  background-color: lightgrey;
  display: inline-block;
  width: 34px;
  height: 28px;
  padding: 2px;
  text-align: center;
}
.rightWing {
  border-radius: 0px 10px 10px 0px;
  background-color: lightgrey;
  display: inline-block;
  width: 34px;
  height: 28px;
  padding: 2px;
  text-align: center;
}
.noWing {
  background-color: transparent;
  display: inline-block;
  width: 34px;
}
.exitRow {
  background-color: rgb(123, 113, 165);
  display: inline-block;
  width: 8px;
  height: 28px;
}
.classBlock {
  display: inline-block;
  width: 26px;
  height: 26px;
  padding: 2px;
  margin-left: 8px;
  text-align: center;
}
.classBlockFirst {
  background-color: rgb(51, 153, 51);
}
.classBlockBusiness {
  background-color: rgb(106, 106, 207);
}
.classBlockEconomy {
  background-color: rgb(241, 241, 104);
}
.destinationBlock {
  display: inline-block;
  height: 26px;
  margin-left: 8px;
  font-weight: bold;
}
.attributesHeader {
  display: inline-block;
  font-size: 76%;
  margin-left: 12px;
}
.seat {
  display: inline-block;
  width: 28px;
  height: 28px;
  background-color: lightgrey;
  padding: 2px;
  text-align: center;
  font-weight: bold;
  &.is-exit {
    border: 2px solid rgb(123, 113, 165);
  }
}
.noSeat {
  background-color: lightgrey;
}
.aisleSeat {
  background-color: lightgrey;
  font-weight: normal;
}
.availableSeat {
  background-color: lightgreen;
}
.boardedSeat {
  background-color: lightsalmon;
}
.blockedSeat {
  background-color: rgb(209, 118, 118);
}
.bufferSeat {
  background-color: rgb(231, 230, 230);
  font-weight: lighter;
}
.bulkheadSeat {
  background-color: rgb(112, 146, 144);
  font-weight: bold;
}
.destinationSeat {
  background-color: rgb(240, 237, 81);
  font-weight: bold;
}
.exitSeat {
  background-color: rgb(123, 113, 165);
}
.galleySeat {
  background-color: lightsteelblue;
}
.handicappedSuitableSeat {
  background-color: lightslategrey;
}
.infantSuitableSeat {
  background-color: lightpink;
}
.nonInfantSuitableSeat {
  background-color: lightseagreen;
}
.unminSuitableSeat {
  background-color: lightgoldenrodyellow;
}
.occupiedSeat {
  background-color: aqua;
}
.preassignedSeat {
  background-color: rgb(54, 190, 54);
}
.toilet {
  background-color: lightyellow;
}
</style>
